import { render, staticRenderFns } from "./blog-post.vue?vue&type=template&id=89562a42&scoped=true&lang=pug"
import script from "./blog-post.vue?vue&type=script&lang=ts"
export * from "./blog-post.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89562a42",
  null
  
)

export default component.exports